import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Textarea } from '@/components/ui/textarea'

interface TextFieldProps {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
}

export const TextField = ({ field, value, onChange }: TextFieldProps) => {
  return (
    <Textarea
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="min-h-[120px] text-sm font-medium leading-relaxed"
      placeholder={field.placeholder}
    />
  )
}
